// Massive monospace countdown + circular progress
const PHASE_LABEL = {
  work: "focus_block",
  short_break: "short_break",
  long_break: "long_break",
};

const PHASE_COLOR = {
  work: "hsl(var(--primary))",
  short_break: "hsl(160 70% 45%)",
  long_break: "hsl(45 95% 55%)",
};

function fmt(secs) {
  const s = Math.max(0, Math.floor(secs));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}

export const TimerDisplay = ({ remaining, total, phase, completedCycles, longBreakInterval }) => {
  const pct = total > 0 ? Math.max(0, Math.min(1, (total - remaining) / total)) : 0;
  const size = 380;
  const stroke = 3;
  const r = (size - stroke * 2) / 2;
  const circumference = 2 * Math.PI * r;
  const offset = circumference * (1 - pct);
  const color = PHASE_COLOR[phase];

  const dotsInCycle = longBreakInterval;
  const currentInCycle = completedCycles % dotsInCycle;

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="font-mono text-xs uppercase tracking-[0.4em] text-muted-foreground" data-testid="timer-phase-label">
        <span className="text-primary">{">"}</span> phase: <span style={{ color }}>{PHASE_LABEL[phase]}</span>
      </div>

      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} stroke="hsl(var(--border))" strokeWidth={stroke} fill="transparent" />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke={color}
            strokeWidth={stroke}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 1s linear" }}
            strokeLinecap="butt"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-mono font-bold text-foreground text-7xl sm:text-8xl tabular-nums tracking-tight" data-testid="timer-countdown">
            {fmt(remaining)}
          </div>
          <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground" data-testid="timer-cycle-count">
            cycle {completedCycles}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2" data-testid="timer-dots">
        {Array.from({ length: dotsInCycle }).map((_, i) => (
          <span
            key={i}
            className="block h-2 w-6"
            style={{
              backgroundColor: i < currentInCycle ? color : "hsl(var(--border))",
              opacity: i === currentInCycle && phase !== "work" ? 0.6 : 1,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default TimerDisplay;
